<template>
    <span class="fl-post-category">
        {{ moduleSettings.sources[parseInt(postObj.source)].label_position == 0 ? postLabel : postTerm }}
    </span>
</template>

<script>
export default {
  props: {
    postObj: {
      type: Object
    },
    moduleSettings: {
      type: Object
    },
    postLabel: {
      type: String
    },
    postTerm: {
      type: String
    }
  }
}
</script>
